import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { GoldSilverInventorySelectedTab } from '~types/redux/state';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { FundTypeEnum } from '~utils/enums';

export default function* watchGetInventoryListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetInventoryListingAttempt', handleGetInventoryListing, api);
}

function* handleGetInventoryListing(api: GoldGateway) {
    const reduxState = store.getState();

    const authToken = reduxState.auth.userDetails.authToken;

    const {
        index,
        filters: {
            goldType,
            branchName,
            metalType,
            ...restOfGetInventoryListingParams
        },
    } = reduxState.gold.goldInventory.inventoryListing;

    const selectedInventoryTab =
        reduxState.gold.goldInventory.inventoryListing.selectedTab;

    if (!index && index !== 0) {
        yield put(
            combinedActions.goldGetInventoryListingFailure(
                ErrorMessages.GenericRequiredFieldNotFilledIn
            )
        );

        return;
    }

    const isGoldTab = [
        GoldSilverInventorySelectedTab.GoldIslamicPaper,
        GoldSilverInventorySelectedTab.GoldIslamicPhysical,
        GoldSilverInventorySelectedTab.GoldConventionalPaper,
        GoldSilverInventorySelectedTab.GoldConventionalPhysical,
    ].includes(selectedInventoryTab);

    const isPhysicalTab = [
        GoldSilverInventorySelectedTab.GoldIslamicPhysical,
        GoldSilverInventorySelectedTab.GoldConventionalPhysical,
        GoldSilverInventorySelectedTab.SilverIslamicPhysical,
        GoldSilverInventorySelectedTab.SilverConventionalPhysical,
    ].includes(selectedInventoryTab);

    const isIslamicTab = [
        GoldSilverInventorySelectedTab.GoldIslamicPaper,
        GoldSilverInventorySelectedTab.GoldIslamicPhysical,
        GoldSilverInventorySelectedTab.SilverIslamicPaper,
        GoldSilverInventorySelectedTab.SilverIslamicPhysical,
    ].includes(selectedInventoryTab);

    const response = yield* call(
        [api, api.getInventoryListing],
        {
            authToken,
            index,

            metalType: isGoldTab ? 1 : 2,

            fundType: isIslamicTab
                ? FundTypeEnum.Islamic
                : FundTypeEnum.Conventional,

            ...(isGoldTab && {
                goldType: isPhysicalTab ? 1 : 2,
            }),

            ...restOfGetInventoryListingParams,
        }
    );

    if (response.status === GatewayResponseStatus.Error) {
        yield put(
            combinedActions.goldGetInventoryListingFailure(
                response.message || ErrorMessages.GenericError
            )
        );

        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(
            combinedActions.goldGetInventoryListingSuccess(
                response.data
            )
        );
    }
}
